import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Inner from "../../components/Inner";
import Title from "../../components/Title";

const FAQ = () => {
  const { t } = useTranslation();

  const faqData = [
    {
      question: t("📩 Contact"),
      answer: t(
        "We’re available 24/7. You can reach us by email at info@eduardbelsky.com or via WhatsApp: +386 30 752 475. Feel free to communicate in any language you prefer."
      )
    },
    {
      question: t("🚚 Shipping"),
      answer: t(
        "All artworks are carefully packed in custom wooden crates to ensure they arrive in perfect condition. Unlike many platforms that ship rolled canvases, we send paintings stretched on a frame, saving your time and effort. Ceramic works are also shipped in protective wooden crates to minimize risk. All international shipping is handled by DHL, following high safety standards."
      )
    },
    {
      question: t("💳 Payment"),
      answer: t(
        "We accept modern and secure payment methods, including all major credit cards, Apple Pay, and Google Pay. You can pay in any currency."
      )
    },
    {
      question: t("🔁 Returns"),
      answer: t(
        "If you’re not satisfied with your purchase, you may return the artwork within a reasonable period, and we will refund your payment. Your satisfaction is important to us."
      )
    },
    {
      question: t("🖼 Where can I see the artworks in person?"),
      answer: t(
        "You can view the artworks in person in Izola, a beautiful coastal town in Slovenia. If a visit is not possible, we are happy to provide videos or additional photos of any work upon request."
      )
    },
    {
      question: t("📜 Do you provide certificates of authenticity?"),
      answer: t(
        "Yes. Each piece comes with a signed certificate of authenticity, including title, year, technique, materials, and artist’s signature."
      )
    },
    {
      question: t("📦 Shipping insurance"),
      answer: t(
        "All shipments are fully insured for their total value. In case of damage or loss during transit, we’ll issue a refund or send a replacement, if possible."
      )
    },
    {
      question: t("💬 I’m not an art expert — can you help me choose?"),
      answer: t(
        "Absolutely! Just contact us with a few details about your taste, space, or purpose (e.g., gift), and we’ll offer personalized recommendations."
      )
    },
    {
      question: t("💰 Customs and import duties"),
      answer: t(
        "Prices on the website do not include local customs duties or taxes. These may apply depending on your country and are typically paid by the receiver. DHL helps streamline the customs process, and we’re happy to advise you in advance."
      )
    }
  ];

  const [openIndex, setOpenIndex] = useState(null);

  const handleToggle = idx => {
    setOpenIndex(openIndex === idx ? null : idx);
  };

  return (
    <>
      <Title>{t("Frequently Asked Questions")}</Title>
      <Inner>
        <div className="faq">
          <h1 className="text-5xl pb-12">{t("Frequently Asked Questions")}</h1>
          <ul>
            {faqData.map((item, idx) => (
              <li key={idx} className="mb-6">
                <button
                  onClick={() => handleToggle(idx)}
                  className="w-full text-left font-semibold text-lg focus:outline-none flex justify-between items-center"
                  aria-expanded={openIndex === idx}
                >
                  {item.question}
                  <span className="ml-2 text-2xl">
                    {openIndex === idx ? "˄" : "˅"}
                  </span>
                </button>
                {openIndex === idx && (
                  <div className="mt-2 text-gray-700">{item.answer}</div>
                )}
              </li>
            ))}
          </ul>
        </div>
      </Inner>
    </>
  );
};

export default FAQ;